import { INIT_EVALUATION_DATA, GET_EVALUATION_LIST, UPDATE_EVALUATION_LIST } from '../../actions/modules/ModulesActionsEvaluation';

/**
 * 初始化STATE
 */
export const initialState: any = {
	evaluationData: {},
	// 评论列表
	evaluations: [],
	// 所有评论
	evaluationList: {
		status: '',
		data: undefined,
		page: {
			size: 10,
		},
	},
	// 有效评论
	evaluationListValid: {
		status: '',
		data: undefined,
		page: {
			size: 10,
		},
	},
};

/**
 * evaluation
 */
function evaluation(state: any = initialState, action: any): any {
	const { type, item } = action;

	switch (type) {
		case INIT_EVALUATION_DATA:
			if (action.evaluationData) {
				let evaluateNum: number = Math.floor(action.evaluationData.evaluateNum) || 0;
				let evaluateNumStr: any;
				if (evaluateNum > 999) {
					evaluateNumStr = '999+';
				} else {
					evaluateNumStr = evaluateNum.toString();
				}
				action.evaluationData = {
					...action.evaluationData,
					evaluateNum,
					evaluateNumStr,
				};
			}

			return { ...state, evaluationData: action.evaluationData };
		case GET_EVALUATION_LIST:
			const storeKey: string = action.hasValidFilter ? 'evaluationListValid' : 'evaluationList';

			return {
				...state,
				[storeKey]: action.data,
			};
		case UPDATE_EVALUATION_LIST:
			return {
				...state,
				evaluations: action.list,
			};
		default: {
			return state;
		}
	}
}

export default evaluation;
